import { LOCAL_STORAGE } from "@/shared/client";
import { useGetSpecial, type SpecialPhotoResponse } from "@/shared/server";
import { MEDIA } from "@/styles/common";
import { getDefaultParameters } from "@/utils";
import { Box, Center, Flex, Spinner, Text } from "@chakra-ui/react";
import { CustomSubTitle, CustomText, CustomTitle } from "./magazine.style";

export const Magazine = ({ idx }: { idx: string }) => {
    const { data } = useGetSpecial<SpecialPhotoResponse>({ section: "photos", specialIdx: idx });
    const pensionName = LOCAL_STORAGE.get({ key: "pensionName" });
    const { isMobile } = MEDIA();
    const { idx: pensionIdx } = getDefaultParameters();

    return data ? (
        <Center
            as="section"
            flexDir={isMobile ? "column" : "row"}
            columnGap="64px"
            rowGap={isMobile ? "32px" : "auto"}
            boxSizing="border-box"
            mt={isMobile ? "-64px" : "-128px"}
            mb={isMobile ? "48px" : "0"}
        >
            <Flex w={isMobile ? "100%" : "60%"} flexDir="column" justifyContent="center" rowGap="8px">
                <CustomSubTitle>{pensionName}</CustomSubTitle>
                <CustomTitle pensionIdx={pensionIdx}>
                    <Text>{pensionIdx === "2017" ? `키즈 애니메이션 "고고다이노"` : "OUR PENSION"}</Text>
                    <Text>{pensionIdx === "2017" ? "가평의 새로운 랜드마크 건설 !" : "OF OLD MEMORIES."}</Text>
                </CustomTitle>
                <CustomText>
                    {pensionIdx === "2017"
                        ? "숙박·식사·놀이가 모두 포함된 국내 최초 고고다이노 키즈호텔입니다."
                        : "사랑과 우정이 넘치는 우리들의 이야기가 가슴 속에 가득 채워지기를. 그윽한 향기 우리 삶의 휴식처에서 언제나 함께 할 수 있는 아름다운 사람의 인연으로 남겨지기를."}
                </CustomText>
            </Flex>
            <Flex w="100%" h={isMobile ? "320px" : "736px"} position="relative">
                <Box
                    w={isMobile ? "100%" : "60%"}
                    h="100%"
                    background={`url(${data.imgList[1].imgUrl}) no-repeat center/cover`}
                    borderRadius="24px"
                ></Box>
                <Box
                    w="60%"
                    h="50%"
                    position="absolute"
                    top={isMobile ? "auto" : "50%"}
                    bottom={isMobile ? "-48px" : "auto"}
                    transform={isMobile ? "translateX(50%)" : "translateY(-50%)"}
                    right={isMobile ? "50%" : "0"}
                    background={`url(${data.imgList[0].imgUrl}) no-repeat center/cover`}
                    borderRadius="24px"
                ></Box>
            </Flex>
        </Center>
    ) : (
        <Spinner />
    );
};
